import * as svg from "../../../assets/arrow-right.svg";

import {iconBuilder} from "./iconBuilder";

export const ArrowRightIcon = iconBuilder(svg, "ArrowRightIcon", "0 0 8 8");
